import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import * as Sentry from "@sentry/react";
import Layout from "@/components/Layout";
import MobileLanding from "@/components/MobileLanding";
import RoutesConfig from "@/routes/RoutesConfig";
import { Toaster } from "@/components/ui/toaster";
import { RateLimitModal } from "@/components/common/RateLimitModal";
import { useMobileDetection } from "@/hooks/useMobileDetection";
import ScrollToTop from "@/components/ScrollToTop";
import "./styles/index.css";
import "./styles/global.css";
import useAuthStore from "@/stores/user/authStore";

if (import.meta.env.VITE_NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://973b06d7e7851be3425896af65091f55@o4509246788730880.ingest.de.sentry.io/4509246790107216",
    sendDefaultPii: true,
    // Session Replay,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
      }),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

// const allowedMobileRoutes = ["/about", "/contact", "/terms", "/privacy-policy"];

const App: React.FC = () => {
  const { initializeAuth, setInitialLoading } = useAuthStore();
  const isMobile = useMobileDetection();

  useEffect(() => {
    const init = async () => {
      setInitialLoading(false);
      if (window.location.pathname === "/auth/callback") {
        return;
      }
      await initializeAuth();
    };

    init();
  }, [initializeAuth, setInitialLoading]);

  if (isMobile) {
    return <MobileLanding />;
  }

  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <RoutesConfig />
        <Toaster />
        <RateLimitModal />
      </Layout>
    </Router>
  );
};

export default App;
